import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ADD_FORM_NAME } from 'presentations/constants';
import AddStepCustomization from 'presentations/components/add_step_customization';

const mapStateToProps = (state) => {
  const selector = formValueSelector(ADD_FORM_NAME);
  /* only the form values that will be used in the component */
  const values = selector(state, 'use_standard_colors', 'custom_primary_color', 'logo');

  return {
    values
  };
}

export default connect(mapStateToProps)(AddStepCustomization);



// WEBPACK FOOTER //
// ./presentations/containers/add_step_customization.js